import styled from "styled-components";

import DropdownMenuGroup from "../DropdownMenuGroup/DropdownMenuGroup";
import DropdownMenuTextLink from "../DropdownMenuTextLink/DropdownMenuTextLink";
import NavbarDropdown from "../NavbarDropdown/NavbarDropdown";
import Trigger from "../Trigger/Trigger";
import { DiscoverDropdownIds } from "Header/NavbarRevamp/navbarRevamp.ids";
import messages from "Header/NavbarRevamp/constants/navbarRevamp.messages";
import createAbsolutePath from "createAbsolutePath";

const NavbarDiscoverDropdownContainer = styled.div`
  display: flex;
`;

const NavbarDiscoverDropdown = () => {
  return (
    <NavbarDiscoverDropdownContainer>
      <NavbarDropdown
        trigger={
          <Trigger
            label={messages.discover}
            id={DiscoverDropdownIds.DiscoverTrigger}
          />
        }
      >
        <DropdownMenuGroup>
          <DropdownMenuTextLink
            to={createAbsolutePath("/r/passport")}
            message={messages.passport}
            id={DiscoverDropdownIds.DiscoverOptionPassport}
          />
        </DropdownMenuGroup>
      </NavbarDropdown>
    </NavbarDiscoverDropdownContainer>
  );
};

export default NavbarDiscoverDropdown;
